// menu open
const menuButtonOpen = document.querySelector("#open-menu");

menuButtonOpen.addEventListener("click", function () {
	console.log('aperto')
	document.querySelector("body").classList.toggle("menu-open");
});

window.addEventListener("scroll", function () {
	const header = document.querySelector("header");
  
	if (!header) return; // Esce se non c'è un <header>
  
	if (window.scrollY > 100) {
	  header.classList.add("scrolled");
	} else {
	  header.classList.remove("scrolled");
	}
  });